import { render, staticRenderFns } from "./QuestionEditor.vue?vue&type=template&id=5ae51af0&scoped=true&"
import script from "./QuestionEditor.vue?vue&type=script&lang=ts&"
export * from "./QuestionEditor.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionEditor.vue?vue&type=style&index=0&id=5ae51af0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae51af0",
  null
  
)

export default component.exports